/*
 * Copyright (C) 2018 Bruno López Trigo
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import {
    Typography,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Divider,
    ExpansionPanel,
    ExpansionPanelSummary
} from "@material-ui/core";
import {
    getConfig,
    getDataset,
    deleteAttributeInterval,
    uploadTest,
    getTest,
    deleteAttributeIntervalNormalized,
    getSomeClassifications,
    getSomeLocalExplanation
} from "../global/API";
import {
    PanoramaFishEye,
    Menu,
    Close,
    CloudUpload, ExpandMore
} from "@material-ui/icons";
import { Redirect } from "react-router-dom";
import CustomizedSnackbars from "../global/CustomizedSnackbars";
import Select from "react-virtualized-select";
import "react-select/dist/react-select.css";
import "react-virtualized/styles.css";
import "react-virtualized-select/styles.css";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import LockOpenIcon  from '@material-ui/icons/LockOpenTwoTone';
import LockIcon  from '@material-ui/icons/LockTwoTone';


import AttributeSimple from "./AttributeSimple";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
const TextOnlyTooltip = withStyles({
    tooltip: {
        color: "white",
        backgroundColor: "#ff9800",
        fontSize: "1em"
    }
})(Tooltip);
const styles = theme => ({
    sideBar: {
        padding: 20,
        width:390,
    },
    list: {
        width: 250
    },
    fullList: {
        width: "auto"
    },
    configBar: {
        flexDirection: "row",
        justifyContent: "space-around",
        display: "-webkit-flex",
        webkitFlexWrap: "wrap",
        flexWrap: "wrap"
    },
    chipDataset: {
        color:"white",
        backgroundColor: "#4caf50",
        fontSize: 16,
        margin: 5,
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    },
    upper: {
        textTransform: "uppercase",
        marginTop: 20
    },
    chipAttributes: {
        color:"white",
        fontSize: 16,
        backgroundColor: "#4caf50",
        margin: 5,
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    },
    chipConsequents: {
        color:"white",
        fontSize: 16,
        backgroundColor: "#4caf50",
        margin: 5,
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    },
    chipHigh: {
        fontSize: 16,
        backgroundColor: "#4caf50",
        margin: 5,
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    },
    chipMedium: {
        fontSize: 16,
        backgroundColor: "#ffa000",
        margin: 5,
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    },
    chipLow: {
        fontSize: 16,
        backgroundColor: "#f4511e",
        margin: 5,
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    },
    close: {
        float: "right"
    },
    select: {
        width: "100%",
        padding: 10,
        fontFamily: "Roboto"
    },
    selectDiv: {
        width: "90%",
        padding: 10
    },
    selected: {
        borderBottom: "solid",
        borderBottomColor: "#283593",
        width: "90%",
        padding: 10
    },
    selectLabel: {
        marginRight: 10,
        marginLeft: 10,
        marginTop: 5
    },
    percentage: {
        marginLeft: 10
    },
    button: {
        margin: 10,
        width: "95%"
    },
    buttonConfig: {
        float: "left",
        color:"white",
    },
    plainLogBox:{
        marginLeft:"auto",
        marginRight:"auto",
        marginTop:"20px",
        width:"50%",
        padding:"5px",
        backgroundColor: "#fafafa",
        border: "2px solid #283593",
        textAlign:"center",
        fontFamily:"Roboto"
    },
    plainLogBoxContenedor:{
        textAlign: "center",
    },
});

class ConfigurationPanelSimple extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            left: true,
            loading: true,
            errorsInstance: {},
            errorsAttributeName: {},
            errorsAttributeNameContent: {},
            errorsClassName : {},
            errorsClassNameContent:{},
            errorsPropertyName: {},
            errorsPropertyNameContent:{},
            errorsInterval: {},
            newConfig: true,
            newConfigClasses:true,
            newConfigAttributes:true,
            loadingButton: false,
            loadingButtonDelete: false,
            selected: "test",
            extendedCero :null,
            extendedOne :null,
            extendedTwo :null,
            typesOfInstances:[{value: 0, label: "Test " },{value: 1, label: "Train" }],
            typeInstanceSelected:0,
            selectedTestInstance:0,
            selectedInstance:0,
            helpTool1:true,
            helpTool2:true,
            helpTool3:true,
        };
        this.classify = this.classify.bind(this);
        this.changeLock = this.changeLock.bind(this);
        this.uploadTest = this.uploadTest.bind(this);
        this.clickHelpIcon1 = this.clickHelpIcon1.bind(this);
        this.clickHelpIcon2 = this.clickHelpIcon2.bind(this);
        this.clickHelpIcon3 = this.clickHelpIcon3.bind(this);
    }

    handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        this.setState({
            error: false,
            success: false
        });
    };

    deleteInterval(event) {
        this.setState({
            loadingButtonDelete: true
        });
        debugger;
        if(this.props.algorithm === "FuzzyHoeffdingDecisionTree") {
            var response = deleteAttributeIntervalNormalized(
                this.state.config.dataset,
                this.state.config.attributes[event.currentTarget.name].id,
                event.currentTarget.id,
                this.props.language.id,
                this.props.token
            );

            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        redirect: true
                    });
                } else {
                    this.setState({
                        error: true,
                        message: response.data
                    });
                }
            } else {
                setTimeout(
                    function () {
                        this.getConfig();
                        this.setState({loadingButtonDelete: false});
                    }.bind(this),
                    1000
                );
                this.props.handleGlobalMessage(
                    "warning",
                    this.props.language.labels[this.props.language.id].warningMessageChangeAttribute
                    //"This change in the attribute will not affect the model."
                );
            }
        }else{
            response = deleteAttributeInterval(
                this.state.config.dataset,
                this.state.config.attributes[event.currentTarget.name].id,
                event.currentTarget.id,
                this.props.language.id,
                this.props.token
            );

            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        redirect: true
                    });
                } else {
                    this.setState({
                        error: true,
                        message: response.data
                    });
                }
            } else {
                setTimeout(
                    function () {
                        this.getConfig();
                        this.setState({loadingButtonDelete: false});
                    }.bind(this),
                    1000
                );
            }
        }
    }
    async changeLock()  {
        if(this.state.typeInstanceSelected === 0) {
            this.setState({
                typeInstanceSelected:1,
            })
        }else{
            this.setState({
                typeInstanceSelected:0,
            })
        }
    }


    async componentDidMount() {
        console.log(this.props.dataset);
        if(this.props.dataset==="new") {
            const timer = setTimeout(() => {
                this.setState({helpTool1:false,helpTool2:false,helpTool3:false});
            }, 5000);
            Promise.all([this.getConfig(this.props.datasetNewBeginner), this.getDataset(this.props.datasetNewBeginner)]).then(() => {
                this.setState({
                    loading: false,
                    nameDatasetClassify:this.props.datasetNewBeginner,
                });
            });
        }else if(this.props.dataset === "newScratch"){
            const timer = setTimeout(() => {
                this.setState({helpTool1:false,helpTool2:false,helpTool3:false});
            }, 5000);
            Promise.all([this.getConfig(this.props.datasetNewBeginner), this.getDataset(this.props.datasetNewBeginner)]).then(() => {
                this.setState({
                    loading: false,
                    nameDatasetClassify:this.props.datasetNewBeginner,
                });
            });
        }else{
            Promise.all([this.getConfig(this.props.dataset), this.getDataset(this.props.dataset)]).then(() => {
                const timer = setTimeout(() => {
                    this.setState({helpTool1:false,helpTool2:false,helpTool3:false});
                }, 5000);
                this.setState({
                    loading: false,
                    nameDatasetClassify:this.props.dataset,
                });
            });
        }
    }

    async getTest(name) {
        var response = await getTest(name, this.props.token);

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            } else {
                this.setState({
                    selected: "train"
                });
            }
        } else {
            const labelsTestInstances = response.data.lines.map(
                (instance, index) => ({
                    value: index,
                    label: "Instance " + (index + 1)
                })
            );

            this.setState({
                instancesTest: response.data.lines,
                labelsTestInstances,
                selectedTestInstance: labelsTestInstances[0],
                instanceTestIndex: 0,
                instance: {
                    attributes: response.data.lines[0].attributes,
                    solution: response.data.lines[0].solution
                }
            });
        }
    }

    async getConfig(name) {
        var response = await getConfig(
            name,
            this.props.language.id,
            this.props.token
        );

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            } else {
                this.setState({
                    error: true,
                    message: response.data
                });
            }
        } else {
            var maximo=0;
            for(var i=0;i<response.data.attributes.length;i++){
                if(response.data.attributes[i].name.length>maximo){
                    maximo=response.data.attributes[i].name.length;
                }
            }
            console.log(response)
            this.setState(
                {
                    maximo: maximo,
                    config: response.data,
                    isDefault:
                        response.data.dataset === "beer" ||
                        response.data.dataset === "glass" ||
                        response.data.dataset === "wine" ||
                        response.data.dataset === "iris" ||
                        response.data.dataset === "flavia" ||
                        response.data.dataset === "vehicle"||
                        response.data.dataset === "ACB" ||
                        response.data.dataset === "PIMA" ||
                        response.data.dataset === "OULAD" ||
                        response.data.dataset === "bank",
                    percentage: 5
                },
                async () => {
                    this.getTest(name);
                }
            );
        }
    }

    async getDataset(name) {
        var response = await getDataset(name, this.props.token);

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            }
            this.setState({
                error: true,
                message: response.data
            });
        } else {
            const labelsInstances = response.data.lines.map((instance, index) => ({
                value: index,
                label: "Instance " + (index + 1)
            }));

            this.setState({
                instances: response.data.lines,
                labelsInstances,
                selectedInstance: labelsInstances[0],
                instanceIndex: 0,
                instance: {
                    attributes: response.data.lines[0].attributes,
                    solution: response.data.lines[0].solution
                }
            });
        }
    }

    componentDidUpdate(prevProps,prevState) {
        console.log()
        if (prevProps.language.id !== this.props.language.id) {
            if(this.props.dataset==="new") {
                this.getConfig(this.props.datasetNewBeginner);
            }else if(this.props.dataset === "newScratch"){
                this.getConfig(this.props.datasetNewBeginner);
            }else{
                this.getConfig(this.props.dataset);
            }
        }
        if(prevState.helpTool1=== false && this.state.helpTool1===true){
            const timer = setTimeout(() => {
                this.setState({helpTool1:false});
            }, 5000);
        }
        if(prevState.helpTool2=== false && this.state.helpTool2===true){
            const timer = setTimeout(() => {
                this.setState({helpTool2:false});
            }, 5000);
        }
        if(prevState.helpTool3=== false && this.state.helpTool3===true){
            const timer = setTimeout(() => {
                this.setState({helpTool3:false});
            }, 5000);
        }
    }

    handleChange = event => {
        if (event !== null) {
            this.setState({
                selected: "train",
                instanceIndex: event.value,
                selectedInstance: event,
                instance: {
                    attributes: this.state.instances[event.value].attributes,
                    solution: this.state.instances[event.value].solution
                },
                userInstance: null,
            });
            console.log(event.value)
            this.props.selectInstanceChange(event.value)
        }
    };

    handleChangeTest = event => {
        if (event !== null) {
            console.table(this.state.instancesTest[event.value])
            console.log('AQui si chega')
            this.props.selectInstanceChangeTest(event.value)
            this.setState({
                selected: "test",
                instanceTestIndex: event.value,
                selectedTestInstance: event,
                instance: {
                    attributes: this.state.instancesTest[event.value].attributes,
                    solution: this.state.instancesTest[event.value].solution
                },
                userInstance: null
            });
        }
    };


    toggleDrawer = (side, open) => () => {
        this.setState({
            [side]: open
        });
    };

    async getValues(){
        var values = { values: {} };
        console.log(Object.keys(this.state.instance.attributes).length)
        for (var i = 0; i < Object.keys(this.state.instance.attributes).length; i++) {
            values.values[this.state.instance.attributes[i + 1].id] =
                this.state.instance.attributes[i + 1].value;
            if(i===(Object.keys(this.state.instance.attributes).length)-1){
                values["solution"] = this.state.instance.solution;
                return values;
            }
        }
    }

    async uploadTest(event) {
        var response = await uploadTest(
            this.state.nameDatasetClassify,
            event.target.files[0],
            this.props.token
        );

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            } else {
                this.setState({
                    error: true,
                    message: response.data
                });
            }
        } else {
            response = await getTest(this.state.nameDatasetClassify, this.props.token);
            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        redirect: true
                    });
                } else {
                    this.setState({
                        error: true,
                        message: response.data
                    });
                }
            } else {
                const labelsTestInstances = response.data.lines.map(
                    (instance, index) => ({
                        value: index,
                        label: "Instance " + (index + 1)
                    }),
                );
                this.setState({
                    instancesTest: response.data.lines,
                    instanceTestIndex: 0,
                    labelsTestInstances,
                    selectedTestInstance: labelsTestInstances[0],
                    instance: {
                        attributes: response.data.lines[0].attributes,
                        solution: response.data.lines[0].solution
                    }
                });
            }
        }
    }


    async classify() {
        var values= await this.getValues();
        console.log(values)
        if(this.state.typeInstanceSelected===0){
            var response = await getSomeClassifications(
                this.state.nameDatasetClassify,
                this.props.language.id,
                0,
                values,
                this.props.token
            );

            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        redirect: true
                    });
                } else {
                    this.setState({
                        error: true,
                        message: response.data
                    });
                }
            } else {
                console.log(response.data)
                this.setState({
                        classificationsJ48: response.data.classificationsJ48,
                        classificationsREPTree: response.data.classificationsREPTree,
                        classificationsRandomTree: response.data.classificationsRandomTree,
                        classificationsFURIA:response.data.classificationsFURIA,
                        classificationsHoeffdingTreeFuzzy:response.data.classificationsHoeffdingTreeFuzzy,
                        rulesHoeffdingTreeFuzzy:response.data.rulesHoeffdingTreeFuzzy,
                        localExplanationRandomForest:response.data.classificationsRadomForest,
                    },
                    async () =>{
                    this.props.updateTree(this.state.classificationsJ48,
                            this.state.classificationsREPTree,
                            this.state.classificationsRandomTree,
                            this.state.classificationsHoeffdingTreeFuzzy,
                            this.state.classificationsFURIA,values,0)
                        response = await getSomeLocalExplanation(
                            this.state.nameDatasetClassify,
                            this.state.classificationsJ48,
                            this.state.classificationsREPTree,
                            this.state.classificationsRandomTree,
                            this.state.classificationsFURIA,
                            this.state.rulesHoeffdingTreeFuzzy,
                            this.props.language.id,
                            this.props.token
                        );
                        if (response.error) {
                            if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                    redirect: true
                                });
                            } else {
                                this.setState({
                                    error: true,
                                    message: response.data
                                });
                            }
                        } else {
                            this.setState({
                                localExplanationJ48: response.data.j48.clauses,
                                localExplanationREPTree: response.data.repTree.clauses,
                                localExplanationRandomTree: response.data.randomTree.clauses,
                                localExplanationFURIA: response.data.furia.clauses,
                                localExplanationHoeffdingTreeFuzzy: response.data.htFuzzy.clauses,
                            });
                            this.props.updateLocalExplanation(this.state.localExplanationJ48,
                                this.state.localExplanationREPTree,
                                this.state.localExplanationRandomTree,
                                this.state.localExplanationRandomForest,
                                this.state.localExplanationFURIA,
                                this.state.localExplanationHoeffdingTreeFuzzy);
                        }
                    })
            }
        }else{
            response = await getSomeClassifications(
                this.state.nameDatasetClassify,
                this.props.language.id,
                0,
                values,
                this.props.token
            );

            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        redirect: true
                    });
                } else {
                    this.setState({
                        error: true,
                        message: response.data
                    });
                }
            } else {
                console.log(response.data)
                this.setState({
                        classificationsJ48: response.data.classificationsJ48,
                        classificationsREPTree: response.data.classificationsREPTree,
                        classificationsRandomTree: response.data.classificationsRandomTree,
                        classificationsFURIA:response.data.classificationsFURIA,
                        classificationsHoeffdingTreeFuzzy:response.data.classificationsHoeffdingTreeFuzzy,
                        rulesHoeffdingTreeFuzzy:response.data.rulesHoeffdingTreeFuzzy,
                        localExplanationRandomForest:response.data.classificationsRadomForest,
                    },

                    async () => {
                        this.props.updateTree(this.state.classificationsJ48,
                            this.state.classificationsREPTree,
                            this.state.classificationsRandomTree,
                            this.state.classificationsHoeffdingTreeFuzzy,
                            this.state.classificationsFURIA,values,0)
                        response = await getSomeLocalExplanation(
                            this.state.nameDatasetClassify,
                            this.state.classificationsJ48,
                            this.state.classificationsREPTree,
                            this.state.classificationsRandomTree,
                            this.state.classificationsFURIA,
                            this.state.rulesHoeffdingTreeFuzzy,
                            this.props.language.id,
                            this.props.token
                        );
                        if (response.error) {
                            if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                    redirect: true
                                });
                            } else {
                                this.setState({
                                    error: true,
                                    message: response.data
                                });
                            }
                        } else {
                            this.setState({
                                localExplanationJ48: response.data.j48.clauses,
                                localExplanationREPTree: response.data.repTree.clauses,
                                localExplanationRandomTree: response.data.randomTree.clauses,
                                localExplanationFURIA: response.data.furia.clauses,
                                localExplanationHoeffdingTreeFuzzy: response.data.htFuzzy.clauses,
                            });
                            this.props.updateLocalExplanation(this.state.localExplanationJ48,
                                this.state.localExplanationREPTree,
                                this.state.localExplanationRandomTree,
                                this.state.localExplanationRandomForest,
                                this.state.localExplanationFURIA,
                                this.state.localExplanationHoeffdingTreeFuzzy);
                        }
                    })
            }
        }
    }
    handleChangePanel = panel => (event, expanded) => {
        if(panel === 0) {
            this.setState({
                expandedCero: !this.state.expandedCero
            });
        }else if(panel === 1){
            this.setState({
                expandedOne: !this.state.expandedOne
            });
        }else if (panel === 2){
            this.setState({
                expandedTwo: !this.state.expandedTwo
            });
        }else if (panel === 2){
            this.setState({
                expandedThree: !this.state.expandedThree
            });
        }

    };
    clickHelpIcon1(e){
        e.stopPropagation()
        this.setState({
            helpTool1:!this.state.helpTool1
        })
    }
    clickHelpIcon2(e){
        e.stopPropagation()
        this.setState({
            helpTool2:!this.state.helpTool2
        })
    }
    clickHelpIcon3(e){
        e.stopPropagation()
        this.setState({
            helpTool3:!this.state.helpTool3
        })
    }
    render() {
        const { classes } = this.props;

        if (this.state.config && this.state.instances && this.state.instance) {
            var sideList = (
                <div className={classes.sideBar}>
                    <IconButton
                        className={classes.close}
                        onClick={this.toggleDrawer("left", false)}
                    >

                        <Close />
                    </IconButton>
                    <Typography  variant="h3" component="h3">
                        {this.state.config.dataset}
                    </Typography>
                    <TextOnlyTooltip title={this.props.language.labels[this.props.language.id].help8} open={this.state.helpTool1} placement={"right"}>
                    <ExpansionPanel
                        className={classes.panel}
                        expanded={this.state.expandedCero}
                        onChange={this.handleChangePanel(0)}
                        defaultExpanded={true}
                    >
                        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                            <Typography  variant="h6" component="h6" className={classes.upper}>
                                <PanoramaFishEye />{" "}
                                {this.props.language.labels[this.props.language.id].data}
                            </Typography>
                            <IconButton onClick={ e => this.clickHelpIcon1(e)}>
                                <HelpIcon/>
                            </IconButton>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{display:"block"}}>
                        {this.state.typeInstanceSelected === 0 &&
                            <IconButton onClick={this.changeLock} color="primary" component="span">
                                <LockOpenIcon/>
                            </IconButton>
                            }{ this.state.typeInstanceSelected === 1 &&
                        <IconButton onClick={this.changeLock} color="primary" component="span">
                            <LockIcon/>
                        </IconButton>
                        }
                            <Typography component={"span"} className={classes.selectLabel} variant="body1">
                                {this.props.language.labels[this.props.language.id].test}:
                            </Typography>
                            {this.state.instancesTest && (
                                <Select
                                    className={classes.select}
                                    options={this.state.labelsTestInstances}
                                    value={this.state.selectedTestInstance}
                                    disabled={this.state.typeInstanceSelected===1}
                                    onChange={this.handleChangeTest}
                                />
                            )}
                            {!this.state.instancesTest && (
                                <>
                                    <br/>
                                <Button disabled={this.state.typeInstanceSelected === 1} component="label" color="primary">
                                    {this.props.language.labels[this.props.language.id].uploadTest}{" "}
                                    <CloudUpload />
                                    <input
                                        style={{ display: "none" }}
                                        type="file"
                                        onChange={this.uploadTest}
                                    />
                                </Button>
                                <br/>
                                </>
                            )}
                            {this.state.typeInstanceSelected === 1 &&
                            <IconButton onClick={this.changeLock} color="primary" component="span">
                                <LockOpenIcon/>
                            </IconButton>
                            }{ this.state.typeInstanceSelected === 0 &&
                        <IconButton onClick={this.changeLock} color="primary" component="span">
                            <LockIcon/>
                        </IconButton>
                        }
                            <Typography  component={"span"} className={classes.selectLabel} variant="body1">
                                {this.props.language.labels[this.props.language.id].train}:
                            </Typography>{" "}
                            <Select
                                className={classes.select}
                                options={this.state.labelsInstances}
                                value={this.state.selectedInstance}
                                disabled={this.state.typeInstanceSelected===0}
                                onChange={this.handleChange}
                            />
                            <Button
                                style={{color:"white"}}
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={this.classify}
                            >
                                {this.props.language.labels[this.props.language.id].classify}
                            </Button>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    </TextOnlyTooltip>
                    <TextOnlyTooltip title={this.props.language.labels[this.props.language.id].help6} open={this.state.helpTool2} placement={"right"}>
                    <ExpansionPanel
                        className={classes.panel}
                        expanded={this.state.expandedOne}
                        onChange={this.handleChangePanel(1)}
                        defaultExpanded={true}
                    >
                        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                        <Typography variant="h6" component="h6" className={classes.upper}>
                            <PanoramaFishEye />{" "}
                            {this.props.language.labels[this.props.language.id].attributes}
                        </Typography>
                            <IconButton onClick={e => this.clickHelpIcon2(e)}>
                                <HelpIcon/>
                            </IconButton>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{display:"block"}}>
                        {this.state.config.attributes.map((att, index) => {
                            return (
                                <AttributeSimple
                                    key={index}
                                    att={att}
                                    index={index}
                                    instance={this.state.instance}
                                    language={this.props.language}
                                />
                            )})}
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    </TextOnlyTooltip>
                    <TextOnlyTooltip title={this.props.language.labels[this.props.language.id].help7} placement={"right"} open={this.state.helpTool3}>
                    <ExpansionPanel
                        className={classes.panel}
                        expanded={this.state.expandedTwo}
                        onChange={this.handleChangePanel(2)}
                        defaultExpanded={true}
                    >
                        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                        <Typography variant="h6" component="h6" className={classes.upper}>
                            <PanoramaFishEye />{" "}
                            {this.props.language.labels[this.props.language.id].classes}
                        </Typography>
                            <IconButton onClick={e =>this.clickHelpIcon3(e)}>
                                <HelpIcon/>
                            </IconButton>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{display:"block"}}>
                        <List>
                            {this.state.config.consequents.map((consequent, index) => {
                                return (
                                    <Fragment>
                                        <ListItem>
                                            <ListItemText primary={index + " : " + consequent.name} />
                                        </ListItem>
                                        <Divider />
                                    </Fragment>
                                );
                            })}
                        </List>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    </TextOnlyTooltip>
                </div>
            );
        }

        return (
            !this.state.loading && (
                <div>
                    <Button
                        className={classes.buttonConfig}
                        variant="contained"
                        color="secondary"
                        onClick={this.toggleDrawer("left", true)}
                    >
                        <Menu />
                    </Button>
                    <Drawer
                        open={this.state.left}
                        onClose={this.toggleDrawer("left", false)}
                    >
                        <div style={{width:450}} tabIndex={0} role="button">
                            {sideList}
                        </div>
                    </Drawer>
                    <CustomizedSnackbars
                        openFail={this.state.error}
                        openSuccess={this.state.success}
                        handleClose={this.handleClose}
                        message={this.state.message}
                    />
                    {this.state.redirect && <Redirect to="/" />}
                </div>
            )
        );
    }
}

ConfigurationPanelSimple.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ConfigurationPanelSimple);
